import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';

const Loading = () => {
  const [text, setText] = useState('מכינים עבורכם את פרטי העברת <br /> הבעלות, מיד תוכלו להמשיך בתהליך');
  const [startTime] = useState(Date.now());

  useEffect(() => {
    let animationFrameId;

    const checkTime = () => {
      const elapsed = Date.now() - startTime;
      if (elapsed >= 10000) {
        setText('אנחנו כמעט שם! <br /> חכו איתנו עוד כמה שניות');
      } else {
        animationFrameId = requestAnimationFrame(checkTime);
      }
    };

    animationFrameId = requestAnimationFrame(checkTime);

    return () => cancelAnimationFrame(animationFrameId);
  }, [startTime]);

  return (
    <div className='ownership-transfer-loading'>
      <div className='icon'>
        <Image src={require('../Icons/avatars.svg')} alt='icon' />
      </div>
      <p className='m-title' dangerouslySetInnerHTML={{__html: text}} />
    </div>
  );
};

export default Loading;
